import Reflux from 'reflux';
import { AppActions, StripeActions } from 'actions';
import SteelCompass from 'services/SteelCompass';

const StripeStore = Reflux.createStore({
  listenables: [StripeActions],
  data: {
    exp_month: null,
    exp_year: null,
    number: null,
    object: 'card',
    cvc: null
  },
  getInitialState() {
    return this.data;
  },
  init() {},
  change(props) {
    this.data = {
      ...this.data,
      ...props
    };
    this.trigger(this.data);
  }
});

export default StripeStore;



// WEBPACK FOOTER //
// ./src/js/stores/Stripe.js